import React from 'react';
import buildingImg from '../assets/building.png';

const ThankYou = () => {
  return (
    <>
      
{/*  BEGIN: MainHeader  */}

{/*  END: MainHeader  */}
<main className="flex-grow">
{/*  BEGIN: Hero Section  */}
<section className="relative pt-12 pb-20 lg:pt-20 lg:pb-28 overflow-hidden" data-purpose="hero-section">
<div className="container mx-auto px-4 lg:px-8 relative z-10">
<div className="flex flex-col lg:flex-row items-center gap-12">
{/*  Text Content  */}
<div className="w-full lg:w-1/2 space-y-6">
<h1 className="font-script text-5xl md:text-7xl text-brand-gold mb-2">Thank You!</h1>
<h2 className="text-2xl md:text-3xl lg:text-4xl font-serif text-on-surface uppercase tracking-wide leading-tight">
              For Connecting With <br/>
<span className="text-brand-gold font-bold text-3xl md:text-5xl lg:text-6xl mt-2 block">HBB0011 REALTY</span>
              Realtors Pvt. Ltd.
            </h2>
<div className="space-y-4 text-brand-gray text-base md:text-lg max-w-lg mt-8">
<p>Your interest means a lot to us.</p>
<p>Our team has received your request and will get in touch with you shortly.</p>
<p>We look forward to helping you find the perfect property and build a brighter future together.</p>
</div>
<div className="pt-8">
<div className="inline-block relative mb-2">
  <span className="text-xl md:text-2xl font-sans font-bold text-transparent bg-clip-text bg-gradient-to-r from-brand-gold to-yellow-200 uppercase tracking-widest relative z-10">HABEEB RAHIMAN M</span>
  <div className="absolute -bottom-1 left-0 w-1/3 h-[2px] bg-brand-gold"></div>
</div>
<div className="text-sm text-brand-gray tracking-wider uppercase">Founder &amp; CEO</div>
</div>
</div>
{/*  Image Content  */}
<div className="w-full lg:w-1/2 relative">
<div className="relative w-full aspect-[4/3] lg:aspect-[3/4] rounded-2xl overflow-hidden border border-brand-gold/20 shadow-2xl shadow-brand-gold/5">
{/*  Using standard placeholder as requested by instructions if image not provided  */}
<img alt="HBB0011 Signature Tower and CEO" className="w-full h-full object-cover" src={buildingImg}/>
{/*  Overlay elements imitating the original design  */}
<div className="absolute top-8 left-8 glass-panel p-4 rounded-lg hidden md:block">
<div className="flex items-center gap-2 mb-1">
<svg className="h-6 w-auto text-brand-gold" fill="currentColor" viewbox="0 0 100 40">
<path d="M10,20 C10,14.477 14.477,10 20,10 C25.523,10 30,14.477 30,20 C30,25.523 25.523,30 20,30 C14.477,30 10,25.523 10,20 Z" fill="none" stroke="currentColor" strokeWidth="2"></path>
<path d="M25,20 C25,14.477 29.477,10 35,10 C40.523,10 45,14.477 45,20 C45,25.523 40.523,30 35,30 C29.477,30 25,25.523 25,20 Z" fill="none" stroke="currentColor" strokeWidth="2"></path>
<text fill="white" font-size="20" font-weight="bold" x="50" y="26">11</text>
</svg>
</div>
<div className="text-on-surface font-bold text-sm tracking-widest uppercase">HBB0011</div>
<div className="text-[0.6rem] text-brand-gray uppercase tracking-widest">Signature Tower</div>
</div>
</div>
{/*  Decorative gradient behind image  */}
<div className="absolute inset-0 bg-gradient-to-tr from-brand-gold/10 to-transparent rounded-2xl -z-10 translate-x-4 translate-y-4"></div>
</div>
</div>
</div>
</section>
{/*  END: Hero Section  */}
{/*  BEGIN: Quote Section  */}
<section className="py-12 border-y border-white/5" data-purpose="quote-section">
<div className="container mx-auto px-4 text-center">
<h3 className="text-xl md:text-2xl lg:text-3xl font-serif text-on-surface max-w-4xl mx-auto leading-relaxed">
<span className="text-brand-gold text-4xl leading-none align-top">“</span>
          At HBB0011 Realty, we don't just build properties, <br className="hidden md:block"/>
<span className="text-brand-gold">we build trust, relationships, and beautiful futures.</span>
<span className="text-brand-gold text-4xl leading-none align-top">”</span>
</h3>
</div>
</section>
{/*  END: Quote Section  */}
{/*  BEGIN: Values Section  */}
<section className="py-16 bg-brand-card/30" data-purpose="values-section">
<div className="container mx-auto px-4 lg:px-8">
<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
{/*  Value Item 1  */}
<div className="flex flex-col items-center text-center space-y-4">
<div className="w-16 h-16 rounded-full border border-brand-gold/30 flex items-center justify-center text-brand-gold">
<svg className="w-8 h-8" fill="none" stroke="currentColor" viewbox="0 0 24 24"><path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></path></svg>
</div>
<p className="text-sm font-medium text-on-surface uppercase tracking-wider">Premium<br/>Projects</p>
</div>
{/*  Value Item 2  */}
<div className="flex flex-col items-center text-center space-y-4 relative">
<div className="hidden lg:block absolute top-8 -left-1/2 w-full h-[1px] bg-brand-gold/20"></div>
<div className="w-16 h-16 rounded-full border border-brand-gold/30 flex items-center justify-center text-brand-gold relative bg-brand-navy z-10">
<svg className="w-8 h-8" fill="none" stroke="currentColor" viewbox="0 0 24 24"><path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></path></svg>
</div>
<p className="text-sm font-medium text-on-surface uppercase tracking-wider">Trusted<br/>Relationships</p>
</div>
{/*  Value Item 3  */}
<div className="flex flex-col items-center text-center space-y-4 relative">
<div className="hidden lg:block absolute top-8 -left-1/2 w-full h-[1px] bg-brand-gold/20"></div>
<div className="w-16 h-16 rounded-full border border-brand-gold/30 flex items-center justify-center text-brand-gold relative bg-brand-navy z-10">
<svg className="w-8 h-8" fill="none" stroke="currentColor" viewbox="0 0 24 24"><path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></path></svg>
</div>
<p className="text-sm font-medium text-on-surface uppercase tracking-wider">Uncompromising<br/>Quality</p>
</div>
{/*  Value Item 4  */}
<div className="flex flex-col items-center text-center space-y-4 relative">
<div className="hidden lg:block absolute top-8 -left-1/2 w-full h-[1px] bg-brand-gold/20"></div>
<div className="w-16 h-16 rounded-full border border-brand-gold/30 flex items-center justify-center text-brand-gold relative bg-brand-navy z-10">
<svg className="w-8 h-8" fill="none" stroke="currentColor" viewbox="0 0 24 24"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></path></svg>
</div>
<p className="text-sm font-medium text-on-surface uppercase tracking-wider">Customer<br/>Centric</p>
</div>
{/*  Value Item 5  */}
<div className="flex flex-col items-center text-center space-y-4 relative col-span-2 md:col-span-1 md:col-start-2 lg:col-start-5 lg:col-span-1">
<div className="hidden lg:block absolute top-8 -left-1/2 w-full h-[1px] bg-brand-gold/20"></div>
<div className="w-16 h-16 rounded-full border border-brand-gold/30 flex items-center justify-center text-brand-gold relative bg-brand-navy z-10">
<svg className="w-8 h-8" fill="none" stroke="currentColor" viewbox="0 0 24 24"><path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></path></svg>
</div>
<p className="text-sm font-medium text-on-surface uppercase tracking-wider">Long-Term<br/>Value</p>
</div>
</div>
</div>
</section>
{/*  END: Values Section  */}
{/*  BEGIN: Stats Section  */}
<section className="py-16 border-t border-white/5" data-purpose="stats-section">
<div className="container mx-auto px-4 lg:px-8">
<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 divide-x divide-white/10 text-center">
<div className="px-4">
<div className="text-4xl md:text-5xl font-serif text-brand-gold mb-2">10+</div>
<div className="text-sm text-brand-gray uppercase tracking-widest">Years of<br/>Excellence</div>
</div>
<div className="px-4">
<div className="text-4xl md:text-5xl font-serif text-brand-gold mb-2">25+</div>
<div className="text-sm text-brand-gray uppercase tracking-widest">Premium<br/>Projects</div>
</div>
<div className="px-4">
<div className="text-4xl md:text-5xl font-serif text-brand-gold mb-2">5000+</div>
<div className="text-sm text-brand-gray uppercase tracking-widest">Happy<br/>Families</div>
</div>
<div className="px-4">
<div className="text-4xl md:text-5xl font-serif text-brand-gold mb-2">8+</div>
<div className="text-sm text-brand-gray uppercase tracking-widest">Cities Across<br/>India</div>
</div>
<div className="px-4 col-span-2 md:col-span-1 md:col-start-2 lg:col-start-5 lg:col-span-1 border-t md:border-t-0 pt-8 md:pt-0 mt-8 md:mt-0 border-white/10">
<div className="text-4xl md:text-5xl font-serif text-brand-gold mb-2">1</div>
<div className="text-sm text-brand-gray uppercase tracking-widest">Promise<br/>Trust Forever</div>
</div>
</div>
</div>
</section>
{/*  END: Stats Section  */}
{/*  BEGIN: CTA Section  */}
<section className="py-16" data-purpose="cta-section">
<div className="container mx-auto px-4 lg:px-8">
<div className="border border-white/10 rounded-xl overflow-hidden flex flex-col md:flex-row items-stretch">
{/*  CTA Image  */}
<div className="w-full md:w-1/3 h-64 md:h-auto relative">
<img alt="Modern Building" className="w-full h-full object-cover" src={buildingImg}/>
</div>
{/*  CTA Content  */}
<div className="w-full md:w-2/3 p-8 lg:p-12 flex flex-col justify-center bg-gradient-to-r from-brand-card to-brand-navy">
<div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
<div className="space-y-2">
<p className="text-brand-gold text-sm font-semibold tracking-widest uppercase">LET'S BUILD YOUR TOMORROW, TOGETHER</p>
<h3 className="text-3xl lg:text-4xl font-serif text-on-surface leading-tight">
                  Your Dream Property is Just <br/>
                  a Conversation Away.
                </h3>
</div>
<div className="flex flex-col gap-4 w-full lg:w-auto shrink-0">
<a className="bg-brand-gold text-brand-navy px-6 py-4 rounded text-sm font-bold uppercase tracking-wider hover:bg-surface-container transition-colors flex items-center justify-between gap-4" href="#">
<span className="flex items-center gap-2">
<svg className="w-5 h-5" fill="none" stroke="currentColor" viewbox="0 0 24 24"><path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path></svg>
                    SCHEDULE A CONSULTATION
                  </span>
<svg className="w-5 h-5" fill="none" stroke="currentColor" viewbox="0 0 24 24"><path d="M14 5l7 7m0 0l-7 7m7-7H3" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path></svg>
</a>
<a className="bg-transparent border border-white/20 text-on-surface px-6 py-4 rounded text-sm font-bold uppercase tracking-wider hover:border-brand-gold hover:text-brand-gold transition-colors flex items-center justify-between gap-4" href="#">
<span className="flex items-center gap-2">
<svg className="w-5 h-5" fill="none" stroke="currentColor" viewbox="0 0 24 24"><path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path></svg>
                    EXPLORE OUR PROJECTS
                  </span>
<svg className="w-5 h-5" fill="none" stroke="currentColor" viewbox="0 0 24 24"><path d="M14 5l7 7m0 0l-7 7m7-7H3" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path></svg>
</a>
</div>
</div>
</div>
</div>
</div>
</section>
{/*  END: CTA Section  */}
{/*  BEGIN: Testimonial Section  */}
<section className="py-12 pb-20" data-purpose="testimonial-section">
<div className="container mx-auto px-4 lg:px-8 max-w-5xl">
<div className="flex flex-col md:flex-row items-center gap-8 relative border-t border-b border-white/10 py-12">
<div className="w-full md:w-2/3 space-y-4 text-center md:text-left relative">
<div className="flex justify-center md:justify-start text-brand-gold mb-4 gap-1">
<svg className="w-5 h-5 fill-current" viewbox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
<svg className="w-5 h-5 fill-current" viewbox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
<svg className="w-5 h-5 fill-current" viewbox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
<svg className="w-5 h-5 fill-current" viewbox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
<svg className="w-5 h-5 fill-current" viewbox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
</div>
<p className="text-lg md:text-xl text-on-surface italic relative z-10 pl-4 border-l-4 border-brand-gold/50">
              "HBB0011 Realty delivered beyond our expectations. The quality, transparency, and support they provide is truly outstanding."
            </p>
</div>
<div className="w-full md:w-1/3 flex items-center justify-center md:justify-start gap-4 border-t md:border-t-0 md:border-l border-white/10 pt-6 md:pt-0 md:pl-8">
<img alt="Ramesh Menon" className="w-16 h-16 rounded-full object-cover border-2 border-brand-gold" src={buildingImg}/>
<div>
<h4 className="font-bold text-on-surface text-lg">Ramesh Menon</h4>
<p className="text-sm text-brand-gray">Business Owner</p>
<p className="text-sm text-brand-gray">Kochi</p>
</div>
<div className="text-brand-gold text-4xl leading-none self-start ml-auto opacity-30">,,</div>
</div>
</div>
</div>
</section>
{/*  END: Testimonial Section  */}
</main>
{/*  BEGIN: Footer  */}

{/*  END: Footer  */}
{/*  WhatsApp Floating Button (simulated)  */}
<div className="fixed bottom-6 right-6 z-50">
<a className="w-14 h-14 bg-green-500 rounded-full flex items-center justify-center text-on-surface shadow-lg shadow-green-500/30 hover:bg-green-600 transition-colors" href="#">
<svg className="w-8 h-8" fill="currentColor" viewbox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"></path></svg>
</a>
</div>

    </>
  );
};

export default ThankYou;
